import {Component, EventEmitter, Input, Output, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { CoachesService } from '../services/coaches.service';
import {AlertsService} from 'app/common/components/alerts/services/alerts.service';
import { IPayoutRatesModel, PaymentTypeAlias, PaymentTypeAliasDisplayName } from 'app/common/models/coach-rate.model';
import { ICourseModel } from 'app/common/models/course.model';

@Component({
  selector: 'app-rate-element-add',
  templateUrl: './rate-element-add.component.html',
  styleUrls: ['./rate-element-add.component.scss']
})
export class RateElementAddComponent implements OnInit {
  public isEnableAdd: boolean = false;
  public form: FormGroup;
  public coursesValue: any; 
  @Input() coachId: string;
  @Input() courses: Array<ICourseModel>;
  @Output() result = new EventEmitter<IPayoutRatesModel>();

  constructor(
    protected coachesService: CoachesService,
    private alertsService: AlertsService
  ) { }

  ngOnInit() {
    this.form = new FormGroup({
      paymentTypeAlias: new FormControl('', Validators.required),
      salary: new FormControl(0, Validators.required),
      personalClassRate: new FormControl(0, Validators.required),
      fixedClassRate: new FormControl(0, Validators.required),
      personInGroupRate: new FormControl(0, Validators.required),
      subscriptionPercentRate: new FormControl(0, Validators.required),
      forUnlimitedRate: new FormControl(0, Validators.required),
      effectiveSinceDate: new FormControl('', [Validators.required]),
      classesRate: new FormControl('', Validators.required),
      personsRate: new FormControl('', [Validators.required])
    });

    // --- выключаем все контролы ---
    this.form.get('fixedClassRate').disable();
    this.form.get('personInGroupRate').disable();
    this.form.get('personalClassRate').disable();
    this.form.get('subscriptionPercentRate').disable();
    this.form.get('forUnlimitedRate').disable();
    this.form.get('classesRate').disable();
    this.form.get('personsRate').disable();
  }

  public addRate() {
    this.isEnableAdd = true;
  }

  public closeAdd() {
    this.isEnableAdd = false;
  }

  public async save(): Promise<any> {
    let req: any;
    const personsRate = this.form.value.hasOwnProperty("personsRate") ? this.form.get('personsRate').value : "";
    const classesRate = this.form.value.hasOwnProperty("classesRate") ? this.form.get('classesRate').value : "";
    let universalRate = "";
    if (classesRate || personsRate) {
      universalRate = `${classesRate}/${personsRate}`;
    }
    req = {
      paymentTypeAlias: this.form.get('paymentTypeAlias').value,
      salary: this.form.get('salary').value,
      forUnlimitedRate: this.form.get('forUnlimitedRate').value,             
      personalClassRate: this.form.get('personalClassRate').value,        
      subscriptionPercentRate: this.form.get('subscriptionPercentRate').value,
      effectiveSinceDate: this.form.get('effectiveSinceDate').value,
      coachId: this.coachId,
      fixedClassRate: this.form.get('fixedClassRate').value,
      personInGroupRate: this.form.get('personInGroupRate').value,
      universalRate: universalRate,
      coursesIds: this.coursesValue
    }
    await this.coachesService.saveRate(req).then(async (e) => {
      if (e) {
        this.isEnableAdd = false;
        this.result.emit(e);
        this.alertsService.alert.next({
          type: 'success',
          message: 'Транзакция сохранена',
          header: 'Успех',
          position: 'top',
          timeout: 2000
        });
      } else {
        console.error(e);
      }
    });
  }

  public changeAlias(alias){
    this.form.get('salary').setValue(0);
    if (alias == PaymentTypeAlias.class)
    {
      this.form.get('fixedClassRate').enable();
    }
    else
    {
      this.form.get('fixedClassRate').setValue(0);
      this.form.get('fixedClassRate').disable();
    }

    if (alias == PaymentTypeAlias.personInGroup)
    {
      this.form.get('personInGroupRate').enable();
      //this.form.get('personalClassRate').enable();
    }
    else
    {
      this.form.get('personInGroupRate').disable();
      //this.form.get('personalClassRate').disable();
      this.form.get('personInGroupRate').setValue(0);
      //this.form.get('personalClassRate').setValue(0);
    }

    if (alias == PaymentTypeAlias.subscription || alias == PaymentTypeAlias.pctWithMissed ||alias == PaymentTypeAlias.pctWithoutMissed )
    {
      this.form.get('subscriptionPercentRate').enable();
      this.form.get('forUnlimitedRate').enable();
    }
    else
    {
      this.form.get('subscriptionPercentRate').disable();
      this.form.get('forUnlimitedRate').disable();
      this.form.get('subscriptionPercentRate').setValue(0);
      this.form.get('forUnlimitedRate').setValue(0);
    }
    // if (alias == PaymentTypeAlias.progressiveRate )
    //   {
    //     this.form.get('personsRate').enable();
    //     this.form.get('classesRate').enable();
    //   }
    //   else
    //   {
    //     this.form.get('classesRate').disable();
    //     this.form.get('personsRate').disable();
    //     this.form.get('classesRate').setValue(0);
    //     this.form.get('personsRate').setValue(0);
    //   }
    // if (alias == PaymentTypeAlias.pctWithoutMissed)
    //   {
    //     this.form.get('subscriptionPercentRate').enable();
    //     this.form.get('forUnlimitedRate').enable();
    //   }
    //   else
    //   {
    //     this.form.get('subscriptionPercentRate').disable();
    //     this.form.get('forUnlimitedRate').disable();
    //     this.form.get('subscriptionPercentRate').setValue(0);
    //     this.form.get('forUnlimitedRate').setValue(0);
    //   }
    // if (alias == PaymentTypeAlias.pctWithMissed)
    //   {
    //     this.form.get('subscriptionPercentRate').enable();
    //     this.form.get('forUnlimitedRate').enable();
    //   }
    //   else
    //   {
    //     this.form.get('subscriptionPercentRate').disable();
    //     this.form.get('forUnlimitedRate').disable();
    //     this.form.get('subscriptionPercentRate').setValue(0);
    //     this.form.get('forUnlimitedRate').setValue(0);
    //   }
  }

  public readonly _PaymentTypeAliases = Object.keys(PaymentTypeAlias).filter(
    key => key !== 'subscription' && //Больше не используется
    key !== 'withoutRate'
  ); 
  public readonly PaymentTypeAliasDisplayName = PaymentTypeAliasDisplayName;
  public onCoursesChange(coursesValue: Array<string>) {
    this.coursesValue = coursesValue.join(',');
  }
}
